import { useRef } from 'react';
import { useTheme } from '@mui/material';

import useWindowScrollPosition from '@/utils/useScrollPosition';

export const useClipBottom = <T extends HTMLElement>(padding: number, bottom: number) => {
  const ref = useRef<T | null>(null);
  const { spacing } = useTheme();

  useWindowScrollPosition(({ scrollY }) => {
    if (!ref.current) return;

    const clipHeight = `calc(100vh - ${spacing(bottom)} + ${scrollY}px - ${ref.current.offsetTop}px)`;
    const points = [
      [spacing(-padding), spacing(-padding)],
      [`calc(100% + ${spacing(padding)})`, spacing(-padding)],
      [`calc(100% + ${spacing(padding)})`, clipHeight],
      [spacing(-padding), clipHeight]
    ]
      .map((coordinates: string[]) => coordinates.join(' '))
      .join(', ');

    ref.current.style.clipPath = `polygon(${points})`;
  });

  return [ref];
};
